import { render } from "./PlankGame.vue?vue&type=template&id=3c51917a&scoped=true"
import script from "./PlankGame.vue?vue&type=script&lang=js"
export * from "./PlankGame.vue?vue&type=script&lang=js"

import "./PlankGame.vue?vue&type=style&index=0&id=3c51917a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c51917a"]])

export default __exports__